import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';

export const es = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Aprendizaje',
    PAGE_SUBTITLE:
      'Visualiza el consumo de la plataforma de aprendizaje. Cursos propios vs catálogo Crehana, evolución trimestral, certificaciones y satisfacción.',
    NEW_TAG: 'Nuevo',
    FRESHNESS_PREFIX: 'Última actualización:',
    FRESHNESS_DATE: '14 may, 09:00 AM',
    PRODUCT_SELECTOR_LABEL: 'Producto',
    PRODUCT_SELECTOR_HELPER: 'Selecciona el producto que quieres analizar',
    PRODUCT_GENERAL: 'General',
    PRODUCT_LEARNING: 'Aprendizaje',
    BREADCRUMB_ROOT: 'Analytics Hub',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_LEARNING: 'Aprendizaje',
    TAB_GENERAL: 'General',
    TAB_PATHS: 'Por rutas',
    TAB_COURSES: 'Por cursos',
    TAB_USERS: 'Por usuarios',
    TAB_PLACEHOLDER_PATHS: 'Contenido de rutas próximamente',
    TAB_PLACEHOLDER_COURSES: 'Contenido de cursos próximamente',
    TAB_PLACEHOLDER_USERS: 'Contenido de usuarios próximamente',
    EMPTY_TITLE: 'No hay módulos disponibles',
    EMPTY_DESCRIPTION:
      'Cuando haya datos de aprendizaje disponibles, los verás aquí.',
    ERROR_TITLE: 'Error al cargar el dashboard',
    ERROR_RETRY: 'Reintentar',
  },
};
